const state = {
    hruser:{},
    hrusercontracts:[],

};

const getters = {
    getHrUser: state => state.hruser,
    getHrUserContracts: state => state.hrusercontracts,
};

const actions = {
    setHrUser: (store, payload) => store.commit("HRUSER_SET",payload),
    setHrUserContracts: (store, payload) => store.commit("HRUSERCONTRACTS_SET", payload),
};

const mutations = {
    HRUSER_SET: (state, payload) => state.hruser = payload,
    HRUSERCONTRACTS_SET: (state, payload) => state.hrusercontracts = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
